import styled from "styled-components";
import { theme } from "../../helpers/theme";
import logoSvg from "../../assets/icons/logo-text.svg";
import man from "../../assets/icons/man.svg"
import vector from "../../assets/icons/vector1.svg"
// import ig from "../../assets/icons/ig.svg"
// import fb from "../../assets/icons/fb.svg"
// import link from "../../assets/icons/link.svg"
import { useLocation, useNavigate } from "react-router-dom";
import SessionService from "../../services/session-service";
import { url } from "../../utils/url";
import Divider from "@mui/material/Divider";

const Footer = () => {
  const navigate = useNavigate();
  const user = SessionService.getUser();

  const _visibleFooter: string[] = [
    url.homePage,
    url.aboutUs,
    url.faq,
    url.offer,
    url.regulations,
    url.privacyPolicy,
    url.contact,
  ]
  const location = useLocation();

  let isFooterIsVisible: boolean = true;
  let isMainPage: boolean = true;

  _visibleFooter.includes(location.pathname) ? isFooterIsVisible = true : isFooterIsVisible = false;


  return (
    <>
      {(isFooterIsVisible && !user) ?
        <>
          {location.pathname === url.homePage ?
            <Divider sx={{
              paddingTop: '20px',
            }} /> : <></>}
          <Container>

            <ContentContainer>
              <LogoContent>
                <LogoFooter src={logoSvg} />
                {/* <SocialLinksContainer>
              <SocialTitle>Bądź na bierząco</SocialTitle>
              <SocialIcons>
                <SocialIcon src={ig} />
                <SocialIcon src={fb} />
                <SocialIcon src={link} />
              </SocialIcons>
            </SocialLinksContainer> */}
              </LogoContent>

              <NavLinksContainer>
                <NavLinks>
                  <Link onClick={() => navigate(url.homePage)}>Strona główna</Link>
                  <Link onClick={() => navigate(url.offer)}>Oferta</Link>
                  <Link onClick={() => navigate(url.aboutUs)}>O nas</Link>
                  {/* <Link >Cennik</Link> */}
                </NavLinks>
                <NavLinks>
                  <Link onClick={() => navigate(url.faq)}>FAQ</Link>
                  {/* <Link >Obsługa klienta</Link>
                <Link >Pomoc</Link> */}
                  <Link onClick={() => navigate("/contact")}>Kontakt</Link>
                </NavLinks>
              </NavLinksContainer>

              <ImgSection>
                <ImgMan src={man} />
                <ImgVector src={vector} />
                <ImgTextOne>Nietypowe towary do magazynowania?</ImgTextOne>
                <ImgTextTwo>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting.
                </ImgTextTwo>
                {/* <ImgTextThree>Obsługa klienta </ImgTextThree> */}
              </ImgSection>
            </ContentContainer>

            <FooterContainer>
              <Copyright>&#169; e-magazyn 2022</Copyright>
              <PolicyLinks>
                <StatuteLink onClick={() => navigate(url.regulations)}>Regulamin</StatuteLink>
                <PolicyLink onClick={() => navigate(url.privacyPolicy)}> Polityka Prywatności</PolicyLink>
              </PolicyLinks>
            </FooterContainer>
          </Container>
        </>
        :
        <></>}
    </>
  );
};

export default Footer;

const Container = styled.footer`
  font-family: ${theme.fonts.interMedium};
  font-style: normal;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 30px;
`;

//
const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  align-items: center;

  @media ${theme.device.laptop} {
    align-items: flex-start;
    flex-direction: row;
  }
`;

const LogoContent = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 30px;
  margin-right: 10px;

  @media ${theme.device.laptop} {
    align-items: flex-start;
    width: 20%;
    padding: 0px;
  }
`;

const LogoFooter = styled.img`
  margin: 0;
  padding: 0;
`;

// const SocialLinksContainer = styled.div`
// margin-top: 3rem;
// `;
// const SocialTitle = styled.p`
//   color: ${theme.colors.gray01_secondaryText};
// `;
// const SocialIcons = styled.div`
//   display: flex;

// `;

// const SocialIcon = styled.img`
// margin-inline: 7px;
// `;

const NavLinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  // margin-block: 2rem;

  @media ${theme.device.laptop} {
    width: 35%;
  }
`;
const NavLinks = styled.div`
  display: flex;
  flex-direction: column;
  width: 45%;
  align-items: center;

  @media ${theme.device.laptop} {
    align-items: flex-start;
  }
`;

const ImgSection = styled.div`
  max-width: 360px;
  height: 240px;
  background-color: white;
  border-radius: 10px;
  display: none;
  grid-template-columns: 50%;
  grid-template-rows: 20% 20% 40% 20%;

  @media ${theme.device.laptop} {
    display: grid;
  }
`;

const ImgText = styled.p`
  margin: 0;
  padding: 0;
  z-index: 1;
  font-size: 14px;
`;

const ImgTextOne = styled(ImgText)`
  grid-row: 2/3;
  grid-column: 2;
`;
const ImgTextTwo = styled(ImgText)`
  font-style: normal;
  font-weight: 300;
  padding-right: 2rem;
  grid-row: 3/4;
  grid-column: 2;
`;
// const ImgTextThree = styled(ImgText)`
//   grid-row: 4/5;
//   grid-column: 2;
// `;

const ImgMan = styled.img`
  // width: 100%;
  height: 100%;
  grid-row: 2/5;
  grid-column: 1/3;
  z-index: 1;
  margin-left: 1rem;
`;

const ImgVector = styled.img`
  // width: 100%;
  height: 100%;
  grid-row: 1/5;
  grid-column: 1/3;
`;

//
const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  margin-top: 3rem;
  flex-direction: column-reverse;
  @media ${theme.device.laptop} {
    justify-content: space-between;
    flex-direction: row;
  }
`;

const Copyright = styled.span`
 white-space:nowrap;
  width: 45%;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.7rem;
  @media ${theme.device.laptop} {
    justify-content: flex-start;
  }
`;
const PolicyLinks = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 45%;
  flex-direction: column;
  align-items: center;

  @media ${theme.device.laptop} {
    flex-direction: row;
  }
`;
const Link = styled.div`
  text-decoration: none;
  font-size: 16px;
  color: ${theme.colors.gray01_secondaryText};
  margin-block: 0.7rem;
  cursor: pointer;

  &:hover {
    color: ${theme.colors.black_primaryText};
  }
`;

const StatuteLink = styled(Link)`
  font-size: 14px;
  margin-right: 1rem;
`;

const PolicyLink = styled(Link)`
  width: 10rem;
  font-size: 14px;
`;